<template>
  <button
    aria-label="play video"
    @click="playVideo"
  >
    <slot />
  </button>
</template>

<script>

export default {
  mounted () {
    const videoWrapper = this.$el.closest('.video-ui')
    const video = videoWrapper.querySelector('video')

    video.addEventListener('click', () => {
      if (!video.paused) {
        video.pause()
      } else {
        video.play()
      }
    })

    video.addEventListener('pause', () => { videoWrapper.classList.remove('playing') })
    video.addEventListener('play', () => { videoWrapper.classList.add('playing') })
  },
  methods: {
    playVideo () {
      const videoWrapper = this.$el.closest('.video-ui')
      const video = videoWrapper.querySelector('video')
      video.play()
    }
  },
}
</script>
